
<form [formGroup]="form">
  <div class="row">
    <div class="col-md-6 form-group">
      <label>{{ 'workflow-email.name' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['title']"></app-input-with-error>
    </div>
    <div class="col-md-6 form-group">
      <label>{{ 'workflow-email.identifier' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['identifier']"></app-input-with-error>
    </div>
    <div class="col-md-12 form-group">
      <label>{{ 'workflow-email.recipients' | translate }}</label>
      <p-multiSelect [options]="users" optionLabel="name" [maxSelectedLabels]="undefined" [showHeader]="false"
          formControlName="allRecipients" [filter]="false" class="w-100" display="chip">
          <ng-template pTemplate="footer">
            <div class="input-group ">
              <input
                [ngClass]="{'is-invalid': !isEmailValid}"
                type="email"
                (keydown.enter)="addCustomMail()"
                class="form-control"
                [placeholder]="'workflow-email.custom-mail' | translate"
                #customMail
                (click)="$event.stopPropagation()"
              >
              <!-- stopPropagation() provides a workaround for a v18 regression bug causing a focus switch on click -->
              <button class="btn btn-outline-success" type="button" (click)="addCustomMail()"><span class="material-symbols-outlined">add</span></button>
            </div>
        </ng-template>
      </p-multiSelect>
      <div class="invalid-feedback">
        <ul>
          <li>{{ 'error.required' | translate }}</li>
        </ul>
      </div>
    </div>
    <div class="col-md-12 form-group">
      <label>{{ 'workflow-email.subject' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['subject']"></app-input-with-error>
    </div>
    <div class="col-md-12 form-group">
      <label>{{ 'workflow-email.template-content' | translate }}</label>
      <app-editor
        [ngClass]="{'invalid-editor': form.get('htmlContent')?.invalid && form.get('htmlContent')?.touched}"
        [(value)]="code"
        [editorConfig]="modules"
        (contentChange)="setHtmlContent($event)"
      ></app-editor>
    </div>
  </div>
  <div *ngIf="form.get('htmlContent')?.invalid && form.get('htmlContent')?.touched" class="invalid-feedback d-block">
    <ul>
      <li>{{ 'error.required' | translate }}</li>
    </ul>
  </div>
  <div class="form-text">{{ 'workflow-email.help' | translate }}</div>
</form>
<app-error [error]="error"></app-error>
@if (emailSentSuccessfully) {
  <div class="alert alert-success" role="alert">
    {{ 'workflow-email.test-success' | translate }}
  </div>
}
